export default __webpack_public_path__ + "static/media/csv.bf18393f.svg";